import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CheckIcon, CopyIcon } from '@radix-ui/react-icons';
import { Button, ButtonProps } from '../button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import React from 'react';
import { toast } from 'sonner';

type Props = {
  text: string;
  slot?: {
    button?: ButtonProps;
  };
  variant?: 'default' | 'icon';
  children?: React.ReactNode;
  tooltip?: string;
  iconCopy?: React.ReactNode;
  activeToast?: boolean;
};
function CopyButton({
  text,
  slot,
  variant = 'default',
  children = 'Copy',
  tooltip,
  iconCopy,
  activeToast,
}: Props) {
  const [hasCopied, setHasCopied] = React.useState(false);

  const handleCopy = React.useCallback(() => {
    setHasCopied(true);
    if (activeToast) {
      toast.message('Copied to clipboard');
    }
    const timer = setTimeout(() => {
      setHasCopied(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [activeToast]);

  const IconCopy = iconCopy || <CopyIcon className="h-3 w-3" />;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <CopyToClipboard text={text} onCopy={handleCopy}>
              {variant === 'default' ? (
                <Button
                  variant="default"
                  startIcon={
                    hasCopied ? <CheckIcon className="h-3 w-3" /> : IconCopy
                  }
                  {...slot?.button}
                >
                  {children}
                </Button>
              ) : variant === 'icon' ? (
                <div>
                  {hasCopied ? <CheckIcon className="h-3 w-3" /> : IconCopy}
                </div>
              ) : (
                <></>
              )}
            </CopyToClipboard>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip || 'Copy to clipboard'}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default CopyButton;
